import styled from 'styled-components';
import { screenMd } from 'constants/styles/breakpoints';

export const PageContent = styled.div`
  position: relative;
  background: var(--grey-lighter);
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 70px;

  ${screenMd} {
    margin-bottom: unset;
  }
`;

export const CardsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 10px;
  height: 100%;

  ${screenMd} {
    padding: 0 20px;
  }
`;

export const EmptyState = styled.div`
  color: var(--light-gray-darker);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: var(--font-family-base);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin: 20px;
`;
